import { Upload } from "lucide-react";

export default function ResumeStep({ uploading, onUpload, onSkip }) {
  return (
    <div>
      <label
        className="relative border-2 border-dashed border-border rounded-xl p-8 flex flex-col items-center justify-center text-center cursor-pointer hover:border-primary/50 hover:bg-primary/5 transition-colors"
        data-testid="onboarding-resume-upload"
      >
        <input
          type="file"
          accept=".pdf,.docx"
          onChange={onUpload}
          className="absolute inset-0 opacity-0 cursor-pointer"
        />
        <Upload size={28} className="text-primary mb-3" />
        <div className="font-semibold text-foreground">
          {uploading ? "Parsing…" : "Drop resume here or click to browse"}
        </div>
        <div className="text-xs text-muted-foreground mt-1">PDF or DOCX · max 5MB</div>
      </label>
      <button
        onClick={onSkip}
        className="w-full mt-4 text-xs text-muted-foreground hover:text-foreground transition-colors"
        data-testid="onboarding-resume-skip"
      >
        Skip for now, I&apos;ll upload later →
      </button>
    </div>
  );
}
